import React from "react";
import { Link } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import { List } from "@material-ui/core";
import { ApolloDialogButton } from "../atom/Apollo_Dialog";
import { apollo_useStyles } from "../atom/Apollo_styles";
import { MenuBar, MenuBarData, MenuBarCollapse } from "../atom/Apollo_MenuBar";

export function ApolloSideMenu(Props: { list: MenuBarData[], open: boolean, setPath: any, setOpen: any }) {
  const classes = apollo_useStyles();
  const { list, open, setPath, setOpen } = Props;

  const handleClick = (idx: number) => {
    setPath(list[idx].link);
  }

  return (
    <List className={classes.sideMenu}>
      {list?.map((data, idx) => (
        data.display &&
        <React.Fragment key={idx}>
          {data.type === 1 ?
            <Link to={data.link} className={classes.link}>
              <MenuBar data={data} open={open} />
            </Link>
            : data.type === 2 ?
              <React.Fragment>
                <div onClick={() => handleClick(idx)}>
                  <ApolloDialogButton setOpen={setOpen}>
                    <MenuBar data={data} open={open} />
                  </ApolloDialogButton>
                </div>
              </React.Fragment>
              : data.type === 4 && open ?
                <React.Fragment>
                  <div style={{ display: "flex", padding: "8px 0", alignItems: "center", background: "#5F5F5F", justifyContent: "center" }}>
                    <div style={{ color: "#FFFFFF" }}>
                      {data.title}
                    </div>
                    {data.img && (
                      <div>
                        <img
                          src={data.img}
                          alt="icon"
                          style={{ height: "18px", marginLeft: 8, display: "block" }}
                        />
                      </div>
                    )}
                  </div>
                </React.Fragment>
                : data.type === 4 && !open ?
                  <></>
                  :
                  <MenuBarCollapse data={data} open={open} />
          }
          <Divider />
        </React.Fragment>
      ))}
    </List>
  );
}
